import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomersActions, CustomersActitonTypes } from './customers.actions';
import { Customers } from '../../_models/customers';
import { User } from '../../_models/user';

export interface State extends fromRoot.State {
	customerss: CustomersState;
}

export interface CustomersState {
    currentCustomersId: bigint | null;
    currentCustomers: Customers;
	customersList: Customers[];
	userList: User[];

	filterFields: any;

	error: string;
}

const initialItem: Customers = {
  id: null,
  name: '',
  vat_reg: '',
  postal_code: '',
  addr1: '',
  addr2: '',
  city: '',
  province: '',
  country: '',
  tel: '',
  email: '',
  annotation: '',
  delivery_route: null,
  user_id: null,
  orig_id: '',
  iban: '',
  sepa: null,
  sepa_date: null,
  debt_past: null,
  debt_fut: null,
  pay_past: null,
  pay_fut: null,
  acc_nr: ''
};

const initialState: CustomersState = {
    currentCustomersId: null,
    currentCustomers: initialItem,
	customersList: [],
	userList: [],
	filterFields: [],
	error: ''
};

const getCustomersFeatureState = createFeatureSelector<CustomersState>('customerss');

export const getCurrentCustomersId = createSelector(
	getCustomersFeatureState,
	state => state.currentCustomersId
);

export const getCurrentCustomers = createSelector(
    getCustomersFeatureState,
    getCurrentCustomersId,
    (state, currentCustomersId) => {
        if (currentCustomersId == null) {
            return initialItem;
        } else {
            return currentCustomersId ? state.customersList.find(p => p.id === currentCustomersId) : null;
        }
    }
);

export const getCustomersList = createSelector(
	getCustomersFeatureState,
	state => state.customersList
);

export const getUserList = createSelector(
	getCustomersFeatureState,
	state => state.userList
);

export const getFilterFields = createSelector(
	getCustomersFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getCustomersFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: CustomersActions): CustomersState {

	// console.log('--> Customers Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Customers type: ');
	// console.log(action.type);

	switch (action.type) {

		case CustomersActitonTypes.SetCurrentCustomers:

			console.log('--> Entando en acción SetCurrentCustomers.');

			if (action.payload !== null) {

				return {
					...state,
					currentCustomersId: action.payload.id,
					currentCustomers: action.payload
				};
			} else {
				return {
					...state,
					currentCustomersId: null,
					currentCustomers: initialItem
				};
			}

		case CustomersActitonTypes.SetCurrentCustomersId:

			console.log('--> Entando en acción SetCurrentCustomers.');

			return {
                ...state,
				currentCustomersId: action.payload
			};

		case CustomersActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

        case CustomersActitonTypes.GetCurrentCustomers:

			console.log('--> Entando en acción GetCurrentCustomers.');

			return state;

		case CustomersActitonTypes.ClearCustomers:

			console.log('--> Entando en acción ClearCustomers.');

			return {
					...state,
					currentCustomersId: null
				};


		case CustomersActitonTypes.InicializeCustomers:

			console.log('--> Entando en acción InicializeCustomers.');

			state = initialState;

			return state;


		case CustomersActitonTypes.LoadCustomerssSuccess:

			console.log('--> Entando en acción LoadCustomerssSuccess. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					customersList: action.payload,
					error: ''
				};

		case CustomersActitonTypes.LoadCustomerssFail:

			console.log('--> Entando en acción LoadCustomerssFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					customersList: [],
					error: action.payload
				};

		// case CustomersActitonTypes.UpdateCustomers:

		// 	console.log('--> Entando en acción UpdateCustomers.');

		// 	// state = initialState;

		// 	return state;

		case CustomersActitonTypes.UpdateCustomersSuccess:

			console.log('--> Entando en acción UpdateCustomersSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxCustomersList = [];

			if (action.payload !== undefined) {
				console.log(' -> El proyecto a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxCustomersList = state.customersList.map(
					item => action.payload.id === item.id ? action.payload : item);

					return {
						...state,
						customersList: auxCustomersList,
						currentCustomersId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> La cliente a modificar está vacía.');

				return {
					...state,
					error: 'No se ha podido modificar la cliente.'
				};
			}

		case CustomersActitonTypes.UpdateCustomersFail:

			console.log('--> Entrando en acción UpdateCustomersFail.');

			return {
					...state,
					error: action.payload
				};

		case CustomersActitonTypes.CreateCustomersSuccess:

			console.log('--> Entrando en acción CreateCustomersSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentCustomerss = null;

			if (action.payload !== undefined) {
				console.log(' -> El proyecto creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.customersList.push(action.payload);

					return {
						...state,
						customersList: state.customersList,
						currentCustomersId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El proyecto a crear está vacío.');

				return {
					...state,
					currentCustomersId: null,
					error: 'No se ha podido crear la cliente.'
				};
			}

		case CustomersActitonTypes.CreateCustomersFail:

			console.log('--> Entrando en acción CreateCustomersFail.');

			return {
					...state,
					currentCustomersId: null,
					error: action.payload
				};

		case CustomersActitonTypes.DeleteCustomersSuccess:

			console.log('--> Entrando en acción DeleteCustomersSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentCustomerss = null;

			if (action.payload !== undefined) {
				console.log(' -> El proyecto borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.customersList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de clientes:');
					console.log(filterList);

					return {
						...state,
						customersList: filterList,
						currentCustomersId: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El proyecto a crear está vacío.');

				return {
					...state,
					currentCustomersId: null,
					error: 'No se ha podido crear la cliente.'
				};
			}

		case CustomersActitonTypes.DeleteCustomersFail:

			console.log('--> Entrando en acción DeleteCustomersSuccess.');

			return {
					...state,
					currentCustomersId: null,
					error: action.payload
				};


		case CustomersActitonTypes.LoadUsersSuccess:

			console.log('--> Entando en acción LoadUsersSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					userList: action.payload,
					error: ''
				};

		case CustomersActitonTypes.LoadUsersFail:

			console.log('--> Entando en acción LoadUsersFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					userList: [],
					error: action.payload
				};

		default:
			return state;
	}
}
